/***
 * @file: 
 * @author: xiaoyu.chen
 * @Date: 2025-09-01 16:41:32
 */
import { defineProps } from 'vue'
import { Tag, Button } from 'ant-design-vue'
import ArticlesImg from '~/assets/images/login/logo.png'
import { ReadOutlined } from '@ant-design/icons-vue';
import BaseTag from './base/BaseTag.vue'
export default defineComponent((props, ctx) => {

  const cardSize = ref(0)
  return () => {
    return h('div', {
      class: 'h-vh-360 flex flex-col rd-4 overflow-hidden cursor-pointer',
      style: { 'background-color': 'var(--card-bg)', transform: `translateY(${cardSize.value}px)`, transition: 'transform 0.5s' },
      onMouseenter: () => {
        cardSize.value = -10;
      }, onMouseleave: () => {
        cardSize.value = 0
      }
    }, [
      h('div', { class: 'flex-4 !flex-shrink-0', style: { 'background': 'var(--icon-bg)' } },
        h(ReadOutlined, { class: 'w-full h-full  font-700 text-72px justify-center color-[#fff]' })
      ),
      h('div', { class: 'flex-5 p-vh-20px' }, [
        h('div', { class: 'flex justify-between items-center gap-20px' }, [
          h('span', { class: 'text-12px flex-shrink-0' }, props.article.date),
          h(BaseTag, { color: 'var(--bold-color)', bgColor: 'var(--tag-bg)', class: 'truncate-1', name: props.article.tags, bordered: false, })
        ]),
        h('h3', { class: 'text-18px mt-vh-10px mb-vh-10px font-700 truncate-1', style: { 'color': 'var(--title-color)' } }, props.article.title),
        h('div', { class: 'text-14px truncate-3 line-height-normal mb-vh-[15px] color-[var(--text-color)]' }, props.article.description),
        h(Button, { type: 'link', class: 'ml-[-16px] color-[var(--link-color)]', onClick: () => {
            navigateTo(props.article.path, {
                open: {
                    target: '_blank'
                }
            })
            } }, () => '阅读全文->')
      ])
    ])
  }
}, {
  props: {
    article: {
      type: Object,
      required: true
    }
  },
  emits: ['click'],
}
)